import type { DBRecord } from '../services/PreferencesDB.ts';
import { ICON_EMPTY } from '../services/Directus.ts';
import { Firestore, doc, setDoc, deleteDoc } from '@firebase/firestore';
import { userId } from '../services/FirebaseDB.ts';
import { type Ref } from 'vue';
import { useDocument } from 'vuefire';

export class Task implements DBRecord {
  static Cache: { [id: string]: Ref<any> } = {};

  id: string = crypto.randomUUID();
  createdAt: number = Date.now();
  lastModified: number = Date.now();
  lastUsed: number = 0;
  name: string = 'New Task';
  icon: string = ICON_EMPTY;
  score: number = 1;
  cooldown: number = 0;
  isCooldownReversed: boolean = false;
  expiresIn: number = 0;
  public: boolean = false;
  photoMode: boolean = false;

  static fromPlain(task: any): Task {
    const instance = new Task();
    Object.assign(instance, task);
    return instance;
  }

  async save(db: Firestore, sharedPath: string | null = null) {
    if (sharedPath != null) {
      const [friendId, taskId] = sharedPath.split('/');
      await setDoc(doc(db, `users/${friendId}/tasks/${taskId}`), this.toPlain());
      return;
    }
    await setDoc(doc(db, `users/${userId.value}/tasks/${this.id}`), this.toPlain());
  }
  async delete(db: Firestore) {
    await deleteDoc(doc(db, `users/${userId.value}/tasks/${this.id}`));
  }

  static fetch(db: Firestore, value: string) {
    if (Task.Cache[value]) {
      return Task.Cache[value];
    }

    const parts = value.split('/');
    const friendId = parts[0];
    const taskId = parts[1];

    if (!taskId) {
      console.log('invalid task id');
      return null;
    }

    const docRef = doc(db, 'users', friendId, 'tasks', taskId);

    Task.Cache[value] = useDocument(docRef);

    return Task.Cache[value];
  }

  toPlain(): object {
    return {
      id: this.id,
      createdAt: this.createdAt,
      lastModified: this.lastModified,
      lastUsed: this.lastUsed,
      name: this.name,
      icon: this.icon,
      score: this.score,
      cooldown: this.cooldown,
      isCooldownReversed: this.isCooldownReversed,
      expiresIn: this.expiresIn,
      public: this.public,
      photoMode: this.photoMode,
    };
  }
}
